import Component from 'inferno-component';
import { connect } from 'inferno-redux';
import debounce from 'debounce';
import '../assets/styles/index.css';
import DeckIcon from '../assets/images/decks-icon';
import RightArrow from '../assets/images/right-arrow';
import Card from '../components/Card';
import Hero from '../components/Hero';
import Page from '../components/Page';
import SearchInput from '../components/SearchInput';
import { getWords, getWordsOfTheDay, resetSearchResult } from '../redux/words';

function mapStateToProps(state) {
  return {
    searchResults: state.words.searchResults,
    wordOfTheDay: state.words.wordsOfTheDay[0],
  };
}

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      wordsOfTheDay: [
        {
          word: '',
          definition: {
            dtxt: '',
          },
        },
      ],
      searchTerm: '',
      selectedWord: null,
      searchResults: [],
    };
  }

  componentDidMount() {
    const { searchTerm } = this.state;
    if (searchTerm) {
      return this.props.getWords(searchTerm).then(searchResults => {
        this.setState({
          searchResults,
        });
      });
    }
    return this.props.getWordsOfTheDay();
  }

  updateSearch = debounce(e => {
    const { value } = e.target;
    const sanitizedSearchTerm = value.replace(/[^\w\s]/gi, '');
    this.setState({ searchTerm: sanitizedSearchTerm });
    if (!value) {
      return this.props.resetSearchResult();
    }
    return this.props.getWords(sanitizedSearchTerm).then(searchResults => {
      this.setState({
        searchResults,
      });
    });
  }, 200);

  render() {
    const { wordOfTheDay } = this.props;
    const { isLoading } = this.state;
    return (
      <Page
        footerMode="light"
        isLoading={isLoading}
        navMode="light"
      >
        <div className="home__container">
          <Hero>
            <div className="hero__content">
              <h1>
                <span className="hero--span">
                  Hawaiian <RightArrow />
                </span>{' '}
                English
              </h1>
              <div className="hero--desc">
                Aloha i kēia kahuapaʻa ʻo manomano.io. E ʻimi i ka wehewehena o nā hua ʻōlelo Hawaiʻi ma lalo nei.
                <br />
                Welcome to manomano.io, get started by searching for any Hawaiian word below to see the English definition.
              </div>
              <SearchInput searchClassName="home-page" iconColor="#333" />
            </div>
          </Hero>
          <div className="card__wrapper">
            <Card themeColor="blue">
              <h4 className="card__title">Ka Hua ʻŌlelo o ka Lā</h4>
              <h5 className="card__subtitle">Word of the Day</h5>
              <p className="word-of-the-day__word">{wordOfTheDay.word}</p>
              <p className="word-of-the-day__definition">
                {wordOfTheDay.definition.dtxt}
              </p>
              <a href="/word-of-the-day" className="button">
                Past words of the day &#187;
              </a>
            </Card>
            <Card themeColor="yellow">
              <h4 className="card__title">E Hoʻoulu i Kou Waihona Kāleka Hua ʻŌlelo Hou</h4>
              <h5 className="card__subtitle">Build Flashcard Decks</h5>
              <a href="/flashcards">
                <DeckIcon />
              </a>
            </Card>
          </div>
        </div>
      </Page>
    );
  }
}

export default connect(mapStateToProps, {
  getWords,
  getWordsOfTheDay,
  resetSearchResult,
})(Home);



// WEBPACK FOOTER //
// ./src/pages/Home.js